var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex h-100 align-items-center justify-content-center"},[_c('img',{attrs:{"src":require('@/assets/svg/spinner_black.svg')}})])}
var staticRenderFns = []

export { render, staticRenderFns }